<!--
 * @Author: Niklaus
 * @Date: 2026-01-30 10:00:19
 * @LastEditTime: 2026-02-03 09:34:11
 * @LastEditors: Niklaus
 * @Description: AI智能体
-->
<template>
    <el-container class="h-100p">
        <el-main class="pad-l-15">
            <basic-container>
                <el-card class="mar-b-15 ai-bg">
                    <el-row :gutter="30">
                        <el-col :span="6" v-for="item in data" :key="item.id">
                            <div>
                                <h3 class="ai-title">{{ item.title }}</h3>
                                <el-row>
                                    <el-col :span="12" v-for="child in item.children" :key="child.code"
                                        class="flex-comm" @click.native="handleMenu(child)">
                                        <img :src="'/assets/images/icon/' + child.icon + '.png'" class="i60">
                                        <h3>{{ child.title }}</h3>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </basic-container>
        </el-main>
    </el-container>
</template>

<script>
import { getParamDict } from "@/api/system/dictbiz.js";

export default {
    data() {
        return {
            data: [
                {
                    id: "1",
                    title: "招商智能体",
                    children: [
                        {
                            title: "招商评估",
                            code: "ai-zspg",
                            icon: "ai/icon_zspg",
                        },
                        {
                            title: "招商发布",
                            code: "ai-zsfb",
                            icon: "ai/icon_zsfb",
                        },
                    ],
                },
                {
                    id: "2",
                    title: "产业智能体",
                    children: [
                        {
                            title: "产业匹配智能体",
                            code: "ai-cypp",
                            icon: "ai/icon_cypp",
                        },
                    ],
                },
                {
                    id: "3",
                    title: "展厅智能体",
                    children: [
                        {
                            title: "展厅内容更新计划",
                            code: "ai-ztnr",
                            icon: "ai/icon_ztnr",
                        },
                    ],
                },
                {
                    id: "4",
                    title: "园区智能体",
                    children: [
                        {
                            title: "人员通行",
                            code: "ai-ztnr",
                            icon: "ai/icon_ztnr",
                        },
                        {
                            title: "车辆管理-寻车",
                            code: "ai-clxc",
                            icon: "ai/icon_clxc",
                        },
                        {
                            title: "车辆管理-新能源车位预约",
                            code: "ai-cwyy",
                            icon: "ai/icon_cwyy",
                        },
                        {
                            title: "设备管理",
                            code: "ai-sbgl",
                            icon: "ai/icon_sbgl",
                        },
                    ],
                },
            ],
            aiUrl: {},
        };
    },

    beforeMount() {
        this.getUrl();
    },

    methods: {
        // 获取链接配置
        getUrl() {
            getParamDict({
                paramKey: "AIUrl",
            }).then((res) => {
                if (res.data.success) {
                    this.aiUrl = JSON.parse(res.data.data.paramValue);
                }
            });
        },
        // 在新窗口打开页面
        handleMenu({ code }) {
            window.open(this.aiUrl[code])
        }
    },
};
</script>

<style scoped>
.i60 {
    width: 60px;
    height: 60px;
}

.flex-comm {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 30px;
    transition: all 0.7s;
    cursor: pointer;
}

.flex-comm:hover {

    transform: translateY(-7px) scale(1.02);
}

.ai-title {
    font-size: 20px;
    font-weight: bold;

}

.ai-title::before {
    display: inline-block;
    content: '';
    width: 5px;
    height: 24px;
    background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%);
    margin-right: 10px;
    transform: translateY(4px);
}

.ai-bg {
    background-image: linear-gradient(to top, #a8edea 0%, #fed6e3 100%);
}
</style>
